<div *ngIf="appUpdate" class="app-message">
  <span i18n>Version update available.</span>&nbsp;
  <a class="ml-2 cursor-pointer" (click)="logoutUser()" i18n>Click here to reload the application.</a>
</div>

<header class="app-header">
  <div class="app-header-wrapper">
    <figure class="app-logo-container">
      <a class="app-logo-link logo-frame drop-shadow-xl" [routerLink]="redirectUri">
        <img class="app-logo" [src]="logoUrl" alt="MAKEOS" />
      </a>
    </figure>

    @if (screenSizeDetectorService.isLargeScreen) {
      <div class="app-header-menu-container">
        <thehubz-main-nav class="main-nav-container"></thehubz-main-nav>
      </div>

      <ng-container *ngIf="backgroundProcess$ | async as backgroundProcess">
        <div *ngIf="backgroundProcess.length > 0" class="mr-6">
          <mat-icon class="material-icons-outlined process-icon" [matMenuTriggerFor]="backgroundProcesses">sync</mat-icon>
          <mat-menu #backgroundProcesses="matMenu">
            <menu *ngFor="let process of backgroundProcess" mat-menu-item>
              <mat-icon class="material-icons-outlined">{{ process.icon }}</mat-icon>
              <p>{{ process.description }}</p>
            </menu>
          </mat-menu>
        </div>
      </ng-container>

      <div class="app-header-addendum-container flex">
        @if (brandPortalLink) {
          <div class="brand-portal-link flex" data-test-id="brand-portal-link">
            <a target="_blank" [href]="brandPortalLink" class="flex items-center space-x-2">
              <mat-icon class="material-icons-outlined">trending_flat</mat-icon>
              <span>Zum Markenportal</span>
            </a>
          </div>
        }

        @if (collectionGuideLink) {
          <div class="brand-portal-link flex font-bold nav-item collection-guide-link" data-test-id="collection-guide-link">
            <a target="_blank" [href]="collectionGuideLink" class="nav-item-action collection-guide-action">
              <mat-icon class="material-icons-outlined">info</mat-icon>
              <span i18n>How-to-Guide</span>
            </a>
          </div>
        }

        @if (loggedInUser) {
          <div class="user-profile-container" [matMenuTriggerFor]="userPreference" data-test-id="user-profile">
            <div class="relative">
              <sp-avatar [user]="loggedInUser" [size]="50" [fontSize]="14" [showToolTip]="false" [clickable]="false"></sp-avatar>
            </div>
            <div *ngIf="impersonated" class="relative w-12 h-12 right-8 opacity-90">
              <sp-avatar [user]="impersonated" [size]="50" [fontSize]="14" [showToolTip]="false" [clickable]="false"></sp-avatar>
            </div>

            <mat-menu #userPreference="matMenu" class="header-user-menu">
              <button mat-menu-item (click)="navigateToProfile()" class="profile-button">
                <mat-icon class="material-icons-outlined">account_circle</mat-icon>
                <ng-container i18n>Profile</ng-container>
              </button>

              @if (isGuidedTourEnabled) {
                <div mat-menu-item>
                  <thehubz-guided-tour-button i18n-matTooltip matTooltip="Start a guided tour that explains the most relevant parts of the app." class="flex">
                    <mat-icon class="material-icons-outlined">explore</mat-icon>
                    <ng-container i18n>Tour</ng-container>
                  </thehubz-guided-tour-button>
                </div>
              }

              <button mat-menu-item (click)="logoutUser()" data-test-id="button-logout-profile">
                <mat-icon class="material-icons-outlined">logout</mat-icon>
                <ng-container i18n>Logout</ng-container>
              </button>

              @if (impersonated) {
                <button mat-menu-item (click)="logoutUser(true)" i18n-matTooltip matTooltip="You impersonate this user, click to logout and switch back to your role">
                  <mat-icon class="material-icons-outlined">people_alt</mat-icon>{{ impersonated.name }}
                </button>
              }
            </mat-menu>
          </div>
        } @else {
          <div class="user-profile-container">
            <button (click)="loginRequest.emit(true)" class="main-nav-link">
              <mat-icon class="material-icons-outlined">login</mat-icon>
              <ng-container i18n>Login</ng-container>
            </button>
          </div>
        }
      </div>
    } @else {
      <sp-mobile-navigation>
        <div class="app-header-menu-container">
          <thehubz-main-nav [isMobile]="true" class="main-nav-container"></thehubz-main-nav>
        </div>

        <div class="app-header-addendum-container">
          <div *ngIf="brandPortalLink" class="brand-portal-link nav-item flex" data-test-id="brand-portal-link">
            <a target="_blank" [href]="brandPortalLink" class="nav-item-action flex items-center space-x-2">
              <span>Zum Markenportal</span>
              <mat-icon class="material-icons-outlined">trending_flat</mat-icon>
            </a>
          </div>

          <div *ngIf="collectionGuideLink" class="brand-portal-link nav-item flex font-bold main-nav-link" data-test-id="collection-guide-link">
            <a target="_blank" [href]="collectionGuideLink" class="nav-item-action flex items-center space-x-2">
              <mat-icon class="material-icons-outlined">info</mat-icon>
              <span i18n>How-to-Guide</span>
            </a>
          </div>

          @if (loggedInUser) {
            <div class="user-profile-container">
              <div class="nav-item">
                <button (click)="navigateToProfile()" class="profile-button nav-item-action">
                  <sp-avatar [user]="impersonated || loggedInUser" [size]="25" [fontSize]="14" [showToolTip]="false" [clickable]="false"></sp-avatar>
                  <ng-container i18n>Profile</ng-container>
                </button>
              </div>

              @if (isGuidedTourEnabled) {
                <div class="nav-item">
                  <thehubz-guided-tour-button i18n-matTooltip matTooltip="Start a guided tour that explains the most relevant parts of the app." class="nav-item-action flex">
                    <mat-icon class="material-icons-outlined">explore</mat-icon>
                    <ng-container i18n>Tour</ng-container>
                  </thehubz-guided-tour-button>
                </div>
              }

              <div class="nav-item">
                <button class="nav-item-action button-logout-profile" (click)="logoutUser()" data-test-id="button-logout-profile">
                  <mat-icon class="material-icons-outlined">logout</mat-icon>
                  <ng-container i18n>Logout</ng-container>
                </button>
              </div>

              <div *ngIf="impersonated" class="nav-item">
                <button class="nav-item-action" (click)="logoutUser(true)" i18n-matTooltip matTooltip="You impersonate this user, click to logout and switch back to your role">
                  <mat-icon class="material-icons-outlined">people_alt</mat-icon>{{ impersonated.name }}
                </button>
              </div>
            </div>
          } @else {
            <div class="user-profile-container nav-item">
              <button (click)="loginRequest.emit(true)" class="nav-item-action">
                <mat-icon class="material-icons-outlined">login</mat-icon>
                <ng-container i18n>Login</ng-container>
              </button>
            </div>
          }
        </div>
      </sp-mobile-navigation>
    }
  </div>
</header>
